import { makeStyles } from "@material-ui/core/styles";
import { lightGrey } from "../util/colors";

const styles = makeStyles({
  highlightedRow: {
    backgroundColor: lightGrey,
  },
});

export const highlightRow = (params, rowName) => (params.row.page === rowName ? styles().highlightedRow : "");

export const monthEnglishNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
